var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["vab-anchor-link", _vm.active ? "vab-anchor-link-active" : ""] },
    [
      _c(
        "span",
        {
          class: [
            "vab-anchor-link-title",
            _vm.active ? "vab-anchor-link-title-active" : "",
          ],
          attrs: { title: _vm.title },
          on: { click: _vm.handleClick },
        },
        [_vm._v(" " + _vm._s(_vm.title) + " ")]
      ),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }